<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">

    export const ImageDefaults = {
        "name": "image",

        "outer-container": { 
            "style": {
                "text-align": "center",
                "align-items": "center",
                "z-index": "5",
            }
        },
        "image": {
            "name": "image",
            "style": {
                "width": "150px", 
                "height": "auto", 
                "border-radius": "0px",
                "margin-bottom": "10px"
            },
            "src": "https://i.pinimg.com/originals/40/ab/e3/40abe3f1c51895079d447397badbbf64.png"
        },
        "meta": {
            "order": {
                "image": 1,
            }
        }
    }
    
</script>

<script>


</script>

        
<img data-i-name="image"/>

<style> 

</style>